import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Avatar } from '../avatar';
import { FlexBox } from '../box';
import { styled } from '../styled';
import { getPaletteColor } from '../theme';
import { Typography } from '../typography';
import { withVersion } from '../utils';
export function getChatBubbleColors(variant, type) {
    if (type === 'warning') {
        return {
            backgroundColor: 'components.messages.warning.main',
            color: 'components.messages.warning.contrastText'
        };
    }
    if (type === 'error') {
        return {
            backgroundColor: 'components.messages.error.main',
            color: 'components.messages.error.contrastText'
        };
    }
    if (variant === 'primary') {
        return {
            backgroundColor: 'components.messages.default.sender.main',
            color: 'components.messages.default.sender.contrastText'
        };
    }
    return {
        backgroundColor: 'components.messages.default.receiver.main',
        color: 'components.messages.default.receiver.contrastText'
    };
}
const BubbleContainer = styled(FlexBox)(({ $align }) => ({
    alignSelf: $align === 'left' ? 'flex-start' : 'flex-end',
    maxWidth: '75%'
}));
const Bubble = styled(FlexBox)(({ theme, $variant, $type, $align }) => {
    const { backgroundColor, color } = getChatBubbleColors($variant, $type);
    return {
        borderRadius: $align === 'left'
            ? `0 ${theme.spacing(2)} ${theme.spacing(2)} ${theme.spacing(2)}`
            : `${theme.spacing(2)} 0 ${theme.spacing(2)} ${theme.spacing(2)}`,
        padding: theme.spacing(1, 1),
        flexDirection: 'column',
        gap: theme.spacing(0.5),
        width: 'fit-content',
        alignSelf: $align === 'right' ? 'flex-end' : 'flex-start',
        backgroundColor: getPaletteColor(theme, backgroundColor),
        color: getPaletteColor(theme, color)
    };
});
const ChatBubbleImpl = (props) => {
    const { align, variant, senderName, avatar, timestamp, children, className, type, ...rest } = props;
    const resolvedVariant = variant ?? (align === 'right' ? 'primary' : 'default');
    const resolvedType = type ?? 'default';
    const avatarElement = avatar ? _jsx(Avatar, { ...avatar, size: 18 }) : null;
    return (_jsxs(BubbleContainer, { "$align": align, stack: true, gap: 0.5, className: className, "data-role": rest['data-role'] ?? 'chat-bubble', "data-role-value": rest['data-role-value'], children: [(senderName || avatar) && (_jsxs(FlexBox, { gap: 1, vAlign: "center", hAlign: align === 'left' ? 'flex-start' : 'flex-end', children: [align === 'left' && avatarElement, senderName && (_jsx(Typography, { variant: "body2", fontWeight: "medium", color: "text.primary", children: senderName })), align === 'right' && avatarElement] })), _jsxs(Bubble, { "$variant": resolvedVariant, "$align": align, "$type": resolvedType, children: [typeof children === 'string' ? (_jsx(Typography, { variant: "body2", color: "inherit", children: children })) : (children), timestamp && (_jsx(Typography, { variant: "body2", textAlign: "right", children: timestamp }))] })] }));
};
export const ChatBubble = withVersion(ChatBubbleImpl, '2.0.0');
